



















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class MaintenanceBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly type!: string;

  @Prop() readonly switchActive!: Function;
}
